import type { CookieKey } from "./types/cookieKey.types";
import type { DeleteCookieProps } from "./utils/deleteCookie";
import { deleteCookie } from "./utils/deleteCookie";
import type { GetCookieProps } from "./utils/getCookie";
import { getCookie } from "./utils/getCookie";
import type { SetCookieProps } from "./utils/setCookie";
import { setCookie } from "./utils/setCookie";

export const COOKIE_KEY_HAS_REFRESH_TOKEN: CookieKey = "hashlwrfh";

export type DeleteCookieHasRefreshTokenProps = Omit<DeleteCookieProps, "key">;

export const deleteCookieHasRefreshToken = ({
  ...props
}: DeleteCookieHasRefreshTokenProps = {}) =>
  deleteCookie({ key: COOKIE_KEY_HAS_REFRESH_TOKEN, ...props });

export type GetCookieHasRefreshTokenProps = Omit<GetCookieProps, "key">;

export const getCookieHasRefreshToken = ({
  ...props
}: GetCookieHasRefreshTokenProps = {}) =>
  getCookie<boolean>({ key: COOKIE_KEY_HAS_REFRESH_TOKEN, ...props });

export type SetCookieHasRefreshTokenProps = Omit<SetCookieProps, "key">;

export const setCookieHasRefreshToken = ({
  ...props
}: SetCookieHasRefreshTokenProps) =>
  setCookie({ key: COOKIE_KEY_HAS_REFRESH_TOKEN, ...props });
